import { baseApi } from '.'

export const recuperacionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Solicita recuperacion de clave usando el contexto publico configurado en runtime.
     */
    recuperarClave: builder.mutation({
      query: (correo) => ({
        url: `${window._env_.API_CONTEXTO_RESTABLECER}`,
        method: 'POST',
        body: correo,
      }),
    }),
  }),
})

export const { useRecuperarClaveMutation } = recuperacionApi
